import { render, staticRenderFns } from "./AdminView.vue?vue&type=template&id=a585b6da&scoped=true"
import script from "./AdminView.vue?vue&type=script&lang=js"
export * from "./AdminView.vue?vue&type=script&lang=js"
import style0 from "./AdminView.vue?vue&type=style&index=0&id=a585b6da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a585b6da",
  null
  
)

export default component.exports